<script lang="ts" setup>
import { ref } from 'vue'
import { useFetch } from '@/home/hooks/fetch';
import RecommendArticle from './RecommendArticle.vue'
import InfiniteScroll from '@/home/components/InfiniteScroll.vue';

const { $fetch } = useFetch();
const listing = ref<Record<string, any>>([]);

let page = 1;
const loading = ref(false);
const finished = ref(false);

// 加载更多数据
const loadMoreData = async () => {
  if (finished.value) {
    return;
  }

  const { isSuccess, data } = await $fetch('/information/home_info_list', {
    method: 'post',
    data: {
      pageNum: page,
      pageSize: 10,
    },
  });

  if (isSuccess && data?.records?.length) {
    page++;
    listing.value.push(...data.records);
  }
  else {
    finished.value = true;
  }

  loading.value = false;
}
</script>

<template>
  <section>
    <InfiniteScroll v-model:loading="loading" :finished="finished" @load="loadMoreData">
      <li v-for="(item, index) in listing" :key="index">
        <RecommendArticle :data="item" />
      </li>
    </InfiniteScroll>
  </section>
</template>

<style lang="scss" scoped>
</style>
